import { Type } from '@angular/core';
import { CardData } from 'src/app/models/print-cards/card-data';
import { ShelfTalkerCardData } from 'src/app/models/shelf-talkers/shelf-talker-card-data';
import { CardBackgroundComponent } from 'src/app/modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from 'src/app/modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { BusinessCardStack } from './business-card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { HarlequinBusinessCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/business-cards-2x3/harelquin-business-card-stack-background/harlequin-business-card-stack-background.component';
import { HarlequinBusinessCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/business-cards-2x3/harlequin-business-card-stack-content/harlequin-business-card-stack-content.component';

export class HarlequinBusinessCardStack extends BusinessCardStack {
  getCardBackgroundComponent(data: CardData | ShelfTalkerCardData): Type<CardBackgroundComponent> | null {
    return HarlequinBusinessCardStackBackgroundComponent;
  }

  getCardContentComponent(data: CardData): Type<PrintCardContentComponent> | null {
    return HarlequinBusinessCardStackContentComponent;
  }

  getCardHeightInInches(): number {
    return 1.25;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 12;
  }

  nRows(): number {
    return 6;
  }
}
